import { AssetFields } from '../Asset/query';
export const AuthorFields = `
{
    name
    image ${AssetFields(96, 96)}
}
`;
